import { FormTab, Group, GroupItem, GroupTitle } from "ra-friendsofbabba";

import HelpAlert from "../HelpAlert";
import SignedDocMediaInput from "../inputs/SignedDocMediaInput";
import { useTranslate } from "react-admin";

const SignedDocTab = (props) => {
  const translate = useTranslate();
  return (
    <FormTab {...props} label="resources.technical_reports.tabs.signed_doc">
      <Group wrapper fullWidth>
        <GroupTitle
          title={translate("resources.technical_reports.title.signed_doc")}
          subTitle={translate("resources.technical_reports.help.signed_doc")}
        />
        <Group>
          <GroupItem lg={12} md={12} sm={12}>
            <SignedDocMediaInput source="signed_doc_media" />
          </GroupItem>
        </Group>
      </Group>
      <HelpAlert />
    </FormTab>
  );
};

export default SignedDocTab;
